export default __webpack_public_path__ + "static/media/MB_Main.ac0ee357.png";